<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align:center;">For the passengers and crew</p>
<p style="text-align:center;">of Argonaut Hotel Golf,</p>
<p style="text-align:center;">who fell to earth on</p>
<p style="text-align:center;">Sunday, 4 June 1967.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?269cc65b